var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 17v10h16V17H14Zm18-2v14H12V15h20Zm-2 3H14v4h16v-4Z",
  fill: "#2D2D2D",
  fillRule: "evenodd"
})));
export default SvgCreditCard;